
export function buildManageAssignmentsPageQueryV1(workspaceId: number, tchProjectId: number, viewDefId: string | null)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Assignments.Queries.ManageAssignmentsPageQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ViewDefId': viewDefId
	}
}

